import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    items: [
      { label: '首页', href: '/' },
      { label: '分类浏览', href: '/category/tutorial' },
      { label: '使用教程', href: '/category/tutorial' },
      { label: '常见问题', href: '/category/faq' },
    ],
  },
  {
    title: '帮助支持',
    items: [
      { label: '新用户指南', href: '/article/jmtiantang-new-user-guide' },
      { label: '安全指南', href: '/article/jmtiantang-account-security' },
      { label: '登录问题', href: '/article/jmtiantang-login-issues' },
      { label: '关于我们', href: '/about' },
    ],
  },
  {
    title: '热门文章',
    items: [
      { label: '官方入口最新地址', href: '/article/jmtiantang-official-entry-2026' },
      { label: '内容分类详解', href: '/article/jmtiantang-category-guide' },
      { label: '移动端使用技巧', href: '/article/jmtiantang-mobile-tips' },
      { label: '搜索高级用法', href: '/article/jmtiantang-search-tips' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-background-50 hover:text-primary-400 transition-colors duration-200">
              jm天堂
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              jm天堂是深受用户喜爱的内容平台，本网站为您提供官方入口、最新地址、使用教程及常见问题解答。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between text-xs text-foreground-500">
          <p>&copy; {new Date().getFullYear()} jm天堂官方指南. 保留所有权利.</p>
          <p className="mt-2 sm:mt-0">
            本站为jm天堂官方信息导航平台，致力于为用户提供准确的访问指引。
          </p>
        </div>
      </div>
    </footer>
  );
}